import React from "react";
import { useNavigate } from "react-router-dom";
import { roleEtudiant, roleProf } from "../../../assets/images";
import "./role.css";

const Role = () => {
  const navigate = useNavigate();

  return (
    <div className="role-page">
      <h1 className="role-title">Choisissez Votre Espace</h1>

      <div className="role-options">
        <div
          className="role-card clickable"
          tabIndex={0}
          role="button"
          onClick={() => navigate("/register-student")}
          onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') { navigate("/register-student"); } }}
        >
          <div className="role-image-container">
            <img src={roleEtudiant} alt="Espace élève" className="role-image" />
          </div>
          <h3 className="role-card-title">
            Espace Élève
          </h3>
          <p className="role-card-description">
            Accédez à tous les cours, ressources pédagogiques<br />
            et suivez votre progression personnalisée
          </p>
          <div className="role-button fake-btn">S'inscrire comme élève</div>
        </div>

        <div
          className="role-card clickable"
          tabIndex={0}
          role="button"
          onClick={() => navigate("/register")}
          onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') { navigate("/register"); } }}
        >
          <div className="role-image-container">
            <img
              src={roleProf}
              alt="Espace professeur"
              className="role-image"
            />
          </div>
          <h3 className="role-card-title">
            Espace Professeur
          </h3>
          <p className="role-card-description">
            Créez et partagez vos cours, gérez vos classes<br />
            et accompagnez vos élèves vers la réussite
          </p>
          <div className="role-button fake-btn">S'inscrire comme professeur</div>
        </div>
      </div>

      <button
        className="role-button home-button"
        onClick={() => navigate("/")}
      >
        Retour à la page d'accueil
      </button>
    </div>
  );
};

export default Role;
